import React, { Component } from 'react';
import { Icon, DatePicker } from 'antd';
import moment from 'moment';
import { isFunction } from 'lodash';

import { observer, inject } from 'mobx-react';

const { MonthPicker } = DatePicker;

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class SubscriptionEndFilter extends Component {
  keyStorageStart = `carFilter_subscriptionStart`;
  keyStorageEnd = `carFilter_subscriptionEnd`;

  constructor(props) {
    super(props);

    let defaultState = {};
    const { filterStore } = this.props;
    let { selectedStartMonthSub } = filterStore.appliedFiltersParameters[this.keyStorageStart] || {};
    let { selectedEndMonthSub } = filterStore.appliedFiltersParameters[this.keyStorageEnd] || {};
    if (selectedStartMonthSub !== undefined || selectedEndMonthSub !== undefined) {
      defaultState = { ...defaultState, selectedStartMonthSub: moment(selectedStartMonthSub), selectedEndMonthSub: moment(selectedEndMonthSub) };
    }
    this.state = defaultState;
  }

  componentDidMount() {
    if (this.props.carsStore.cars) {
      this.init(this.props.carsStore.cars);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  init(cars) {
    this.setState({ cars }, () => {
      this.initMonthToM();
    });
  }

  initMonthToM = () => {
    const mm = this.props.carsStore.cars
      .map(car => car.subscriptionEnd)
      .filter((car, index, cars) => cars.indexOf(car) === index)
      .sort((a, b) => {
        if (moment(a).isAfter(b)) {
          return 1;
        }
        if (moment(a).isBefore(b)) {
          return -1;
        }
        return 0;
      });
    this.setState({ startMonthSub: mm[0], endMonthSub: mm[mm.length - 1] });
  };

  selectStartMonthToM = selectedStartMonthSub => {
    const { filterStore } = this.props;
    this.setState({ selectedStartMonthSub: !!selectedStartMonthSub ? moment(selectedStartMonthSub).startOf('month') : null });
    let startMonth = selectedStartMonthSub ? car => moment(car.subscriptionEnd).isSameOrAfter(selectedStartMonthSub) : () => true;
    if (selectedStartMonthSub > 0) {
      filterStore.add('carFilter_subscriptionStart', car => startMonth(car), undefined, {
        selectedStartMonthSub: selectedStartMonthSub.startOf('month').format()
      });
    } else {
      filterStore.remove('carFilter_subscriptionStart');
    }
  };

  selectEndMonthToM = selectedEndMonthSub => {
    const { filterStore } = this.props;
    this.setState({ selectedEndMonthSub: !!selectedEndMonthSub ? moment(selectedEndMonthSub).endOf('month') : null });
    let endMonth = selectedEndMonthSub ? car => moment(car.subscriptionEnd).isSameOrBefore(selectedEndMonthSub) : () => true;
    if (selectedEndMonthSub > 0) {
      filterStore.add('carFilter_subscriptionEnd', car => endMonth(car), undefined, {
        selectedEndMonthSub: selectedEndMonthSub.endOf('month').format()
      });
    } else {
      filterStore.remove('carFilter_subscriptionEnd');
    }
  };

  removeSubscriptionFilter = () => {
    const { filterStore } = this.props;
    this.setState({ selectedStartMonthSub: null, selectedEndMonthSub: null });
    filterStore.remove('carFilter_subscriptionStart');
    filterStore.remove('carFilter_subscriptionEnd');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedStartMonthSub: null,
        selectedEndMonthSub: null
      });
    }
  };

  render() {
    const { selectedStartMonthSub, selectedEndMonthSub } = this.state;
    const { translationsStore, carsStore } = this.props;
    const { startMonthSub, endMonthSub } = carsStore;
    return (
      <div id="daysToMFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.subscriptionEnd')}
          <span>
            {!!selectedStartMonthSub && <span>{moment(selectedStartMonthSub).format(translationsStore.translate('format.YYYYMM'))}</span>}
            {!!selectedEndMonthSub && (
              <span>
                &nbsp;-&nbsp;
                {moment(selectedEndMonthSub).format(translationsStore.translate('format.YYYYMM'))}
              </span>
            )}
            {(!!selectedStartMonthSub || !!selectedEndMonthSub) && <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeSubscriptionFilter} />}
          </span>
        </div>
        <span>
          <MonthPicker
            // disabledDate={aDate => aDate && ((!!selectedEndMonthSub && !!aDate.isAfter(selectedEndMonthSub)) || aDate.isBefore(startMonthSub))}
            disabledDate={aDate => aDate && ((!!selectedEndMonthSub && !!aDate.isAfter(selectedEndMonthSub)) || aDate.isBefore(startMonthSub) || aDate.isAfter(endMonthSub))}
            value={selectedStartMonthSub}
            format={translationsStore.translate('format.YYYYMM')}
            onChange={this.selectStartMonthToM}
          />
          <MonthPicker
            disabledDate={aDate => aDate && ((!!selectedStartMonthSub && !!aDate.isBefore(selectedStartMonthSub)) || aDate.isAfter(endMonthSub) || aDate.isBefore(startMonthSub))}
            value={selectedEndMonthSub}
            format={translationsStore.translate('format.YYYYMM')}
            onChange={this.selectEndMonthToM}
          />
        </span>
      </div>
    );
  }
}
